module.exports = __webpack_public_path__ + "static/media/HandDigtalBackgrond-02-01.0d34fb77.png";